import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js'

export const AsYouTypeFormatter = (input, country = 'US') => {
  if (input === null) return ''
  const safeInput = typeof input === 'number' ? input.toString() : input
  // in order to allow users to backspace without being stuck at parans at 3 digits
  if (safeInput.length === 3) return input
  return new AsYouType(country).input(safeInput)
}

export const isValid = (input, country = 'US') => {
  const phoneNumber = parsePhoneNumberFromString(input, country)
  if (phoneNumber) {
    return phoneNumber.isValid()
  }
  return false
}
